export let tileId: string;

export const setTileId = (value: string) => {
  tileId = value;
};
